module.exports = __webpack_public_path__ + "img/postcard_front.4492e8fd.jpeg";